import React from 'react';
import { Switch } from '@headlessui/react';
import clsx from 'clsx';
import { useBackgroundContext } from '../BackgroundContext/index.js';
export const Toggle = props => {
    const { title, description, checked, disabled = false, onChange } = props;
    const { text500Clsx, backgroundType } = useBackgroundContext();
    const text700Clsx = [
        backgroundType === 'main' && 'text-content-on-background',
        backgroundType === 'surface' && 'text-content',
        backgroundType === 'secondary' && 'text-content-on-topbar',
    ];
    const switchClsx = [
        checked ? 'bg-action-primary' : 'bg-surface-pressed',
        'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full transition-colors ease-in-out duration-200',
        !disabled && 'cursor-pointer',
        disabled && 'opacity-50 cursor-default',
        'focus:outline-none focus-visible:ring',
    ];
    if (title || description) {
        return (React.createElement(Switch.Group, { as: "div", className: "flex items-center justify-between space-s-2" },
            React.createElement("span", { className: "flex-grow flex flex-col" },
                React.createElement(Switch.Label, { as: "span", className: clsx('font-medium', text700Clsx), passive: true }, title),
                React.createElement(Switch.Description, { as: "span", className: clsx('text-sm', text500Clsx) }, description)),
            React.createElement(Switch, { checked: checked, onChange: onChange, className: clsx(switchClsx), disabled: disabled },
                React.createElement("span", { "aria-hidden": "true", className: clsx(checked ? 'translate-x-5 rtl:-translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-surface shadow transform transition ease-in-out duration-200') }))));
    }
    return (React.createElement(Switch, { checked: checked, onChange: onChange, className: clsx(switchClsx), disabled: disabled },
        React.createElement("span", { className: "sr-only" }, title),
        React.createElement("span", { "aria-hidden": "true", className: clsx(checked ? 'translate-x-5 rtl:-translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-surface shadow transform transition ease-in-out duration-200') })));
};
//# sourceMappingURL=Toggle.js.map